var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('section',{staticClass:"py-8"},[_vm._t("default",[_c('p',[_vm._v("Nenhum conteúdo por enquanto...")])])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }